








































import { Component, Mixins, Watch } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import RoleApi from '@/api/identity/role/index'
@Component({
  components: {},
})
export default class EditRoles extends AbpBase {
  id: string | string[] = ''
  formValidate: any = {
    name: '',
    isDefault: false,
    isStatic: false,
    isPublic: false,
    concurrencyStamp: '',
    id: '0',
  }
  ruleValidate: any = {
    name: [
      {
        required: true,
        message: '请输入角色名称',
        trigger: 'blur',
      },
    ],
  }
  mounted() {
    console.log('sss', this.$route)
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.load()
    }
  }
  load() {
    RoleApi.getRole(this.id).then((res) => {
      this.formValidate = res.data
    })
  }
  submit() {
    let vm = this
    let form: any = vm.$refs.formValidate
    form.validate((valid) => {
      if (valid) {
        if (this.id) {
          //update
          RoleApi.putRole(this.formValidate.id, this.formValidate).then(
            (res) => {
              this.$Notice.success({
                desc: '修改成功',
              })
              this.$router.push({
                name: 'rolesmanagement',
              })
            }
          )
        } else {
          //add
          RoleApi.postRole(this.formValidate).then((res) => {
            this.$Notice.success({
              desc: '保存成功',
            })
            this.$router.push({
              name: 'rolesmanagement',
            })
          })
        }
      }
    })
  }
}
